var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9998 5.33337H3.99984C3.64622 5.33337 3.30708 5.47385 3.05703 5.7239C2.80698 5.97395 2.6665 6.31309 2.6665 6.66671V25.3334C2.6665 25.687 2.80698 26.0261 3.05703 26.2762C3.30708 26.5262 3.64622 26.6667 3.99984 26.6667H27.9998C28.3535 26.6667 28.6926 26.5262 28.9426 26.2762C29.1927 26.0261 29.3332 25.687 29.3332 25.3334V6.66671C29.3332 6.31309 29.1927 5.97395 28.9426 5.7239C28.6926 5.47385 28.3535 5.33337 27.9998 5.33337V5.33337ZM26.6665 20C25.6056 20 24.5882 20.4215 23.8381 21.1716C23.0879 21.9218 22.6665 22.9392 22.6665 24H9.33317C9.33317 22.9392 8.91174 21.9218 8.1616 21.1716C7.41145 20.4215 6.39404 20 5.33317 20V12C6.39404 12 7.41145 11.5786 8.1616 10.8285C8.91174 10.0783 9.33317 9.06091 9.33317 8.00004H22.6665C22.6665 9.06091 23.0879 10.0783 23.8381 10.8285C24.5882 11.5786 25.6056 12 26.6665 12V20Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 10.6666C13.0585 10.6666 10.6665 13.0586 10.6665 16C10.6665 18.9413 13.0585 21.3333 15.9998 21.3333C18.9412 21.3333 21.3332 18.9413 21.3332 16C21.3332 13.0586 18.9412 10.6666 15.9998 10.6666ZM15.9998 18.6666C14.5292 18.6666 13.3332 17.4706 13.3332 16C13.3332 14.5293 14.5292 13.3333 15.9998 13.3333C17.4705 13.3333 18.6665 14.5293 18.6665 16C18.6665 17.4706 17.4705 18.6666 15.9998 18.6666Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.37f326e75bfbdefef758954aa7023d02.svg";
export { ForwardRef as ReactComponent };